import React from 'react'
import "../styles/footer.css"


const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <div className='footer_container'>
            <span className='footerTxt'>{currentYear} © All Rights Reserved.</span>
            <span className='footerTxt'>Buit by <span className='loveIcon'>♡</span> Soumyajit Pan</span>
        </div>
    )
}

export default Footer